import React from 'react';
import {
  Button, Row, Col, Input
  , Collapse, Pagination, Table
  , Icon, DatePicker, Spin
} from 'antd';
import {inject, observer} from 'mobx-react';
import AppDatasBody from '../util/AppDatasBody';
import {toJS} from 'mobx';
import AppApplyModal from '../util/AppApplyModal';

const Panel = Collapse.Panel;
const store = ['commonStore','orderStore']
@inject(...store)
@observer
  class App extends React.Component {
  componentDidMount() {
    const {orderStore, location} = this.props;
    orderStore.callOrderData();
    orderStore.getRoutes(location.query);
    orderStore.getPropertyList();
  }

  //申请应用点击
  handleApplyClick() {
    const {orderStore} = this.props;
    orderStore.applyModal = {...orderStore.applyModal, visible: true};
  }

  //添加下拉框点击
  handleMenuClick(e) {
    const {orderStore} = this.props;
    if (e.key !== '') {
      if (e.key === '1') {
        orderStore.callToAddAPP("??todo:所选应用id", e.key)
      } else {
        orderStore.callAddWhereData(e.key)
        orderStore.addModal = {...orderStore.addModal, addWhere: e.key, visible: true};
      }
    }
  }

  //添加应用确认
  handleOk(key, name, type) {
    const {orderStore} = this.props;
    orderStore.callToAddAPP("??todo:所选应用id", key)
    orderStore.addModal = {...orderStore.addModal, visible: false};
  }

  getOrderDatas = () => {
    let { orderStore: { orderDatas } } = this.props;
    orderDatas = toJS(orderDatas);
    let result = [];
    orderDatas.forEach((data) => {
      const swList = data.swList || [];
      result = result.concat(swList);
    })
    return result;
  }

  getPropertyData= (val, key) => {
    const { orderStore } = this.props;
    let { propertyList } = orderStore;
    propertyList = toJS(propertyList);
    if (key === 's_trade') {
      const result = propertyList.find((v) => v.g_id === val);
      if (result) {
        return result.g_name;
      }
    } else if (key === 's_function') {
      let res = '';
      propertyList.forEach((v) => {
        if (v.funcList) {
          const resFunc = v.funcList.find((l) => l.g_id === val);
          if (resFunc) res = resFunc.g_name;
        }
      })
      return res;
    }
    return '';
  }

  render() {
    const server = window.server;
    const {orderStore, location, commonStore} = this.props;
    let { searchValue, propertyList } = orderStore;
    const orderDatas = this.getOrderDatas();
    const columns = [
      {
        key: 's_name',
        title: '项目名称',
        dataIndex: 's_name',
        render: (text, record) => (
          <div style={{fontWeight: 600}} onClick={() => {
            // window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + record.s_wfid);
          }}>{text}</div>
        )
      },
      {
        key: 's_count', title: '预览次数', dataIndex: 's_count',
        render: (text) => (
          <div className='list-table-record-sub'>
            <Icon type="eye-o" className="list-table-record-sub-icon-eye"/>
            <span>{text}次</span>
          </div>
        ),
      },
      { key: 'tms_isbuy_count', title: '下载次数', dataIndex: 'tms_isbuy_count', render: (text) => (
        <div className='list-table-record-sub'>
          <Icon type="download" className="list-table-record-sub-icon-eye"/>
          <span style={{color: '#ffab65'}}>{text}次</span>
        </div>
      ), },
      { key: 's_trade', title: '所属行业', dataIndex: 's_trade', render: (text) => this.getPropertyData(text, 's_trade') },
      { key: 's_function', title: '所属职能', dataIndex: 's_function', render: (text) => this.getPropertyData(text, 's_function') },
      {
        key: 'operation',
        title: '操作',
        width: 150,
        render(text, record, index) {
          return (
            <div>
              {
                record && record.hpid
                  ? <span className='list-table-btn'
                          style={{cursor: 'not-allowed'}}
                          onClick={() => {}
                            // window.open("http://203.110.166.54:8085/homepage/Homepage.jsp?subCompanyId=25&showbtn=0&isfromportal=1&hpid=" + record.hpid)
                          }
                    >
                     预览</span>
                  : <span className='list-table-btn'
                          style={{cursor: 'not-allowed'}}
                          onClick={() => {}
                            // window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + record.s_wfid)
                    }>
                     预览</span>
              }
              <span className='list-table-btn'
                    style={{paddingRight: 24}}
                    onClick={() => {
                      let param = {sw_id: record.sw_id, s_id: record.s_id};
                      let appInfo = [{appId: record.s_number, appName: record.s_name}];
                      commonStore.getApply(param, appInfo);
                    }}>获取</span>
            </div>
          )
        }
      }
    ];
    return (
      <div className='order'>
        <AppDatasBody location={location}>
          <div className="cs-search-mylist">
            <Row>
              <Col span={17}>
                <Row>
                  <Col span={3} style={{paddingTop: 5}}> <label>表单名称：</label> </Col>
                  <Col span={7}>
                    <Input style={{marginRight:10,width:'90%'}} placeholder='请输入表单名称'
                           value={searchValue.appName}
                           onChange={(e) => {
                             orderStore.searchValue = {...searchValue, appName: e.target.value}
                           }}/>
                  </Col>
                  <Col span={7}>
                    <DatePicker
                      placeholder="请输入开始日期"
                      format="YYYY-MM-DD HH:mm:ss"
                      showTime
                      style={{marginRight: 10,width:'90%'}}
                      value={searchValue.startDate}
                      onChange={date => {
                        searchValue.startDate = date;
                      }}
                    />
                  </Col>
                  <Col span={7}>
                    <DatePicker
                      placeholder="请输入结束日期"
                      format="YYYY-MM-DD HH:mm:ss"
                      showTime
                      style={{width:'90%'}}
                      value={searchValue.endDate}
                      onChange={date => {
                        searchValue.endDate = date;
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col span={7}>
                <Col span={16} offset={8}>
                  <Button type="primary"
                          style={{marginRight:10}}
                          onClick={() => {
                            let startDate = searchValue.startDate && searchValue.startDate._d;
                            let endDate = searchValue.endDate && searchValue.endDate._d;
                            orderStore.callOrderData({
                              appName: searchValue.appName,
                              startDate: startDate,
                              endDate: endDate,
                            });
                          }}>搜索</Button>
                  <Button type="ghost"
                          onClick={() => {
                            orderStore.searchValue = {
                              appName: '',
                              startDate: null,
                              endDate: null,
                            };
                            orderStore.callOrderData();
                          }}>重置</Button>
                </Col>
              </Col>
            </Row>
            <div className="list-table orderWfE8-table">
              <Table columns={columns} dataSource={orderDatas} />
            </div>
          </div>
          <AppApplyModal applyModal={commonStore.applyModal}
                         applyApps={commonStore.applyApps}
                         handleCloseModal={() => {
                           commonStore.applyModal = {...commonStore.applyModal, visible: false}
                         }}
          />
        </AppDatasBody>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/order/OrderWfE8.js